// 标签管理相关API
import apiClient from './config'

/**
 * 标签管理API类
 */
export class TagsApi {
  /**
   * 获取所有标签列表（树形结构）
   * @returns {Promise<Object>} 标签列表数据
   */
  async getAllTags() {
    try {
      console.log('=== 获取所有标签列表 ===')

      console.log('发送请求到 /sys-tags/getAllTags')

      // 发送GET请求
      const response = await apiClient.get('/sys-tags/getAllTags')

      console.log('获取标签列表API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('获取标签列表成功')

        // 格式化标签数据
        const formattedTags = this.formatTagsData(data.data || [])

        console.log('格式化后的标签数据:', formattedTags)

        return {
          success: true,
          message: data.message || '获取标签列表成功',
          data: formattedTags,
          total: formattedTags.length
        }
      } else {
        console.error('获取标签列表失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '获取标签列表失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('获取标签列表异常:', error)

      let errorMessage = '获取标签列表失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const status = error.response.status
        const errorData = error.response.data || {}

        if (status === 500) {
          errorMessage = '服务器繁忙，请稍后重试'
        } else if (status === 404) {
          errorMessage = '标签接口不存在'
        } else if (status === 401) {
          errorMessage = '登录已过期，请重新登录'
        } else if (status === 403) {
          errorMessage = '没有权限访问标签数据'
        } else {
          errorMessage = errorData.message || errorData.msg || `服务器错误 (${status})`
        }
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: [],
        total: 0
      }
    }
  }

  /**
   * 分页查询所有标签
   * @param {number} pageNum - 页数
   * @param {number} pageSize - 每页的容量
   * @returns {Promise<Object>} 分页标签数据
   */
  async getAllTagsPage(pageNum = 1, pageSize = 10) {
    try {
      console.log('=== 分页获取标签列表 ===')
      console.log('分页参数:', { pageNum, pageSize })

      // 发送GET请求，使用查询参数
      const response = await apiClient.get('/sys-tags/getAllTagsPage', {
        params: {
          pageNum: pageNum.toString(),
          pageSize: pageSize.toString()
        }
      })

      console.log('分页获取标签列表API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('分页获取标签列表成功')

        // 格式化标签数据
        const formattedTags = this.formatTagsData(data.data.records || [])

        console.log('格式化后的分页标签数据:', formattedTags)

        return {
          success: true,
          message: data.message || '获取标签列表成功',
          data: formattedTags,
          total: data.data.total || 0,
          current: data.data.current || pageNum,
          size: data.data.size || pageSize,
          pages: data.data.pages || 0
        }
      } else {
        console.error('分页获取标签列表失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '获取标签列表失败',
          data: [],
          total: 0,
          current: pageNum,
          size: pageSize,
          pages: 0
        }
      }
    } catch (error) {
      console.error('分页获取标签列表异常:', error)

      let errorMessage = '获取标签列表失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const status = error.response.status
        const errorData = error.response.data || {}

        if (status === 500) {
          errorMessage = '服务器繁忙，请稍后重试'
        } else if (status === 404) {
          errorMessage = '分页标签接口不存在'
        } else if (status === 401) {
          errorMessage = '登录已过期，请重新登录'
        } else if (status === 403) {
          errorMessage = '没有权限访问标签数据'
        } else {
          errorMessage = errorData.message || errorData.msg || `服务器错误 (${status})`
        }
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: [],
        total: 0,
        current: pageNum,
        size: pageSize,
        pages: 0
      }
    }
  }

  /**
   * 格式化标签数据，添加前端需要的字段
   * @param {Array} tags - 原始标签数据
   * @returns {Array} 格式化后的标签数据
   */
  formatTagsData(tags) {
    if (!Array.isArray(tags)) {
      console.warn('标签数据不是数组格式:', tags)
      return []
    }

    // 过滤掉null和undefined的标签，然后格式化
    return tags
      .filter(tag => tag != null)
      .map(tag => this.formatSingleTag(tag))
  }

  /**
   * 格式化单个标签数据
   * @param {Object} tag - 单个标签数据
   * @returns {Object} 格式化后的标签数据
   */
  formatSingleTag(tag) {
    // 空值检查
    if (!tag || typeof tag !== 'object') {
      console.warn('无效的标签数据:', tag)
      return null
    }

    // 格式化时间
    const formatDateTime = (dateTimeStr) => {
      if (!dateTimeStr) return ''
      try {
        const date = new Date(dateTimeStr)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      } catch (e) {
        console.error('时间格式化失败:', e, dateTimeStr)
        return dateTimeStr
      }
    }

    // 递归格式化子标签
    const formatChildren = (children) => {
      if (!children || !Array.isArray(children)) {
        return null
      }
      return children
        .filter(child => child != null)
        .map(child => this.formatSingleTag(child))
        .filter(child => child != null)
    }

    // 调试：检查标签编号字段
    if (tag.encode || tag.tagCode) {
      console.log(`标签 "${tag.tagName}" 的编号:`, {
        encode: tag.encode,
        tagCode: tag.tagCode,
        final: tag.encode || tag.tagCode
      })
    }

    const formattedTag = {
      id: tag.id,
      tagName: tag.tagName || '',
      name: tag.tagName || '', // 兼容字段
      parentId: tag.parentId || 0,
      level: tag.level || 1,
      description: tag.description || '',
      encode: tag.encode || tag.tagCode || null, // 标签编号字段，支持 encode 和 tagCode 两种字段名
      createdTime: formatDateTime(tag.createdTime),
      updatedTime: formatDateTime(tag.updatedTime),
      children: formatChildren(tag.children),
      // 从API直接获取患者数量
      patientCount: tag.patientCount || 0,
      // 前端需要的额外字段
      hasChildren: !!(tag.children && tag.children.length > 0),
      isExpanded: false, // 默认不展开，用户点击展开按钮展开
      type: this.getTagType(tag), // 根据描述或名称推断类型
      status: '启用', // 默认启用状态
      identity: this.getTagIdentity(tag.level), // 根据level确定身份
      // 保留原始数据
      originalData: tag
    }

    return formattedTag
  }

  /**
   * 根据标签信息推断标签类型
   * @param {Object} tag - 标签数据
   * @returns {string} 标签类型
   */
  getTagType(tag) {
    const name = (tag.tagName || '')
    const desc = (tag.description || '')

    // 根据标签名称推断分类
    if (name.includes('诱发因素') || desc.includes('诱发因素')) {
      return '诱发因素'
    } else if (name.includes('维持因素') || desc.includes('维持因素')) {
      return '维持因素'
    } else if (name.includes('睡眠障碍疾病') || desc.includes('睡眠障碍疾病')) {
      return '睡眠障碍疾病'
    } else if (name.includes('睡眠相关疾病') || desc.includes('睡眠相关疾病')) {
      return '睡眠相关疾病'
    } else {
      return '其他'
    }
  }

  /**
   * 获取标签层级的显示名称
   * @param {number} level - 标签层级
   * @returns {string} 层级显示名称
   */
  getLevelDisplayName(level) {
    const levelNames = {
      1: '一级标签',
      2: '二级标签',
      3: '三级标签',
      4: '四级标签',
      5: '五级标签'
    }
    return levelNames[level] || '未知层级'
  }

  /**
   * 获取标签权限身份
   * @param {number} level - 标签层级
   * @returns {string} 身份描述
   */
  getTagIdentity(level) {
    if (level === 1) {
      return '管理员设置'
    } else if (level <= 2) {
      return '管理员/医生设置'
    } else {
      return '医生添加'
    }
  }

  /**
   * 将树形结构的标签数据扁平化（用于表格显示）
   * @param {Array} tags - 树形标签数据
   * @param {Array} result - 结果数组
   * @param {number} displayLevel - 显示层级
   * @returns {Array} 扁平化的标签数组
   */
  flattenTagsForTable(tags, result = [], displayLevel = 0) {
    if (!Array.isArray(tags)) {
      return result
    }

    tags.forEach(tag => {
      // 添加当前标签到结果中，保持原始的level不变，但移除children避免Element Plus自动生成展开按钮
      const flatTag = {
        ...tag,
        displayLevel: displayLevel, // 只用于显示缩进，不改变原始level
        levelDisplayName: this.getLevelDisplayName(tag.level), // 添加层级显示名称
        children: undefined // 移除children属性，避免Element Plus自动生成展开按钮
      }

      result.push(flatTag)

      // 如果有子标签且标签是展开状态，递归添加子标签
      if (tag.children && tag.isExpanded) {
        this.flattenTagsForTable(tag.children, result, displayLevel + 1)
      }
    })

    return result
  }

  /**
   * 切换标签的展开/收起状态
   * @param {Array} tags - 标签数组
   * @param {number} tagId - 要切换的标签ID
   * @param {boolean} forceExpand - 强制展开状态，如果提供则不切换而是设置为指定值
   * @returns {Array} 更新后的标签数组
   */
  toggleTagExpansion(tags, tagId, forceExpand = null) {
    return tags.map(tag => {
      if (tag.id === tagId) {
        return {
          ...tag,
          isExpanded: forceExpand !== null ? forceExpand : !tag.isExpanded
        }
      }

      // 递归处理子标签
      if (tag.children) {
        return {
          ...tag,
          children: this.toggleTagExpansion(tag.children, tagId, forceExpand)
        }
      }

      return tag
    })
  }

  /**
   * 根据搜索条件过滤标签
   * @param {Array} tags - 标签数组
   * @param {Object} searchForm - 搜索条件
   * @returns {Array} 过滤后的标签数组
   */
  filterTags(tags, searchForm) {
    if (!Array.isArray(tags)) {
      return []
    }

    return tags.filter(tag => {
      // 名称过滤
      if (searchForm.name &&
          !tag.tagName.toLowerCase().includes(searchForm.name.toLowerCase())) {
        return false
      }

      // 类型过滤
      if (searchForm.type && tag.type !== searchForm.type) {
        return false
      }

      // 状态过滤
      if (searchForm.status && tag.status !== searchForm.status) {
        return false
      }

      return true
    }).map(tag => {
      // 递归过滤子标签
      if (tag.children) {
        return {
          ...tag,
          children: this.filterTags(tag.children, searchForm)
        }
      }
      return tag
    })
  }

  /**
   * 患者绑定标签
   * @param {number} patientId - 患者ID
   * @param {Array<string>} tagIds - 标签ID列表
   * @returns {Promise<Object>} API响应
   */
  async bindTagToPatient(patientId, tagIds) {
    try {
      console.log('绑定标签到患者:', { patientId, tagIds })

      // 确保tagIds是数组格式
      const tagIdsArray = Array.isArray(tagIds) ? tagIds : [tagIds]
      console.log('转换后的tagIdsArray:', tagIdsArray)

      // 尝试方法1：按照接口文档的array[string]格式，如["1,2"]
      console.log('=== 尝试方法1：接口文档格式 ===')
      try {
        const method1Params = new URLSearchParams()
        method1Params.append('patientId', parseInt(patientId))
        method1Params.append('tagIds', `["${tagIdsArray.join(',')}"]`)

        console.log('方法1参数:', method1Params.toString())
        const response1 = await apiClient.post(`/sys-tags/bindTagToPatient?${method1Params.toString()}`)

        if (response1.data && response1.data.code === 0) {
          console.log('方法1成功!')
          return {
            success: true,
            message: response1.data.message || '标签绑定成功',
            data: response1.data.data
          }
        }
      } catch (error1) {
        console.log('方法1失败:', error1.message)
      }

      // 尝试方法2：每个标签ID作为单独的参数
      console.log('=== 尝试方法2：多个tagIds参数 ===')
      try {
        const method2Params = new URLSearchParams()
        method2Params.append('patientId', parseInt(patientId))
        tagIdsArray.forEach(id => {
          method2Params.append('tagIds', String(id))
        })

        console.log('方法2参数:', method2Params.toString())
        const response2 = await apiClient.post(`/sys-tags/bindTagToPatient?${method2Params.toString()}`)

        if (response2.data && response2.data.code === 0) {
          console.log('方法2成功!')
          return {
            success: true,
            message: response2.data.message || '标签绑定成功',
            data: response2.data.data
          }
        }
      } catch (error2) {
        console.log('方法2失败:', error2.message)
      }

      // 尝试方法3：JSON数组格式
      console.log('=== 尝试方法3：JSON数组格式 ===')
      try {
        const method3Params = new URLSearchParams()
        method3Params.append('patientId', parseInt(patientId))
        method3Params.append('tagIds', JSON.stringify(tagIdsArray))

        console.log('方法3参数:', method3Params.toString())
        const response3 = await apiClient.post(`/sys-tags/bindTagToPatient?${method3Params.toString()}`)

        if (response3.data && response3.data.code === 0) {
          console.log('方法3成功!')
          return {
            success: true,
            message: response3.data.message || '标签绑定成功',
            data: response3.data.data
          }
        }
      } catch (error3) {
        console.log('方法3失败:', error3.message)
      }

      // 尝试方法4：使用request body而不是query params
      console.log('=== 尝试方法4：Request Body格式 ===')
      const response = await apiClient.post('/sys-tags/bindTagToPatient', {
        patientId: parseInt(patientId),
        tagIds: tagIdsArray
      })

      console.log('方法4 - 绑定标签响应:', response)
      console.log('方法4 - 响应状态码:', response.status)
      console.log('方法4 - 响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        console.log('方法4成功!')
        return {
          success: true,
          message: response.data.message || '标签绑定成功',
          data: response.data.data
        }
      } else {
        console.error('所有方法都失败了')
        console.error('最后一次尝试的响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `标签绑定失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('所有绑定方法都失败了，最终异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 404:
            return { success: false, message: '患者或标签不存在' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试\n\n可能原因：\n1. 接口参数格式不正确\n2. 服务器内部错误\n3. 数据库连接问题' }
          default:
            return { success: false, message: data?.message || '绑定标签失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '绑定标签失败，请重试' }
      }
    }
  }

  /**
   * 添加新标签
   * @param {Object} tagData - 标签数据
   * @param {string} tagData.tagName - 标签名称（≤30字符）
   * @param {number} tagData.parentId - 父级标签ID（0表示一级）
   * @param {number} [tagData.level] - 标签层级（可选，系统可自动计算）
   * @param {string} [tagData.description] - 标签描述（≤200字符）
   * @returns {Promise<Object>} 添加结果
   */
  async addTag(tagData) {
    try {
      console.log('=== 添加新标签 ===')
      console.log('标签数据:', tagData)

      // 验证必填字段
      if (!tagData.tagName || tagData.tagName.trim() === '') {
        return {
          success: false,
          message: '标签名称不能为空'
        }
      }

      if (tagData.tagName.length > 30) {
        return {
          success: false,
          message: '标签名称不能超过30个字符'
        }
      }

      if (tagData.description && tagData.description.length > 200) {
        return {
          success: false,
          message: '标签描述不能超过200个字符'
        }
      }

      // 构建请求数据
      const requestData = {
        tagName: tagData.tagName.trim(),
        parentId: parseInt(tagData.parentId) || 0,
        description: tagData.description || ''
      }

      // 如果指定了level，则添加到请求中
      if (tagData.level !== undefined && tagData.level !== null) {
        requestData.level = parseInt(tagData.level)
      }

      console.log('发送的请求数据:', requestData)
      console.log('请求URL:', '/sys-tags/addTag')
      console.log('请求方法:', 'POST')

      const response = await apiClient.post('/sys-tags/addTag', requestData)

      console.log('添加标签响应:', response)
      console.log('响应状态码:', response.status)
      console.log('响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        return {
          success: true,
          message: response.data.message || '标签添加成功',
          data: response.data.data
        }
      } else {
        console.error('添加标签失败，响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `标签添加失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('添加标签异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 400:
            return { success: false, message: data?.message || '请求参数错误' }
          case 404:
            return { success: false, message: '添加标签接口不存在' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试' }
          default:
            return { success: false, message: data?.message || '添加标签失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '添加标签失败，请重试' }
      }
    }
  }

  /**
   * 删除标签
   * @param {string|number} tagId - 标签ID
   * @returns {Promise<Object>} 删除结果
   */
  async deleteTag(tagId) {
    try {
      console.log('=== 删除标签 ===')
      console.log('标签ID:', tagId)

      // 验证必填参数
      if (!tagId) {
        return {
          success: false,
          message: '标签ID不能为空'
        }
      }

      console.log('发送删除请求:', `/sys-tags/deleteTag?id=${tagId}`)
      console.log('请求方法:', 'DELETE')

      const response = await apiClient.delete(`/sys-tags/deleteTag?id=${tagId}`)

      console.log('删除标签响应:', response)
      console.log('响应状态码:', response.status)
      console.log('响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        return {
          success: true,
          message: response.data.message || '标签删除成功',
          data: response.data.data
        }
      } else {
        console.error('删除标签失败，响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `标签删除失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('删除标签异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 403:
            return { success: false, message: '没有权限删除此标签' }
          case 404:
            return { success: false, message: '标签不存在或已被删除' }
          case 400:
            return { success: false, message: data?.message || '请求参数错误' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试' }
          default:
            return { success: false, message: data?.message || '删除标签失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '删除标签失败，请重试' }
      }
    }
  }

  /**
   * 根据标签ID查询绑定的患者列表
   * @param {string|number} tagId - 标签ID
   * @param {number} current - 当前页码（从1开始）
   * @param {number} size - 每页条数
   * @returns {Promise<Object>} 患者列表数据
   */
  async getPatientsByTagId(tagId, current = 1, size = 10) {
    try {
      console.log('=== 根据标签ID查询绑定患者 ===')
      console.log('查询参数:', { tagId, current, size })

      // 验证必填参数
      if (!tagId) {
        return {
          success: false,
          message: '标签ID不能为空'
        }
      }

      // 构建查询参数
      const params = {
        tagId: tagId,
        current: current.toString(),
        size: size.toString()
      }

      console.log('发送请求:', '/sys-tags/getPatientsByTagId')
      console.log('请求参数:', params)

      const response = await apiClient.get('/sys-tags/getPatientsByTagId', { params })

      console.log('查询标签患者响应:', response)
      console.log('响应状态码:', response.status)
      console.log('响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        const data = response.data.data || {}

        return {
          success: true,
          message: response.data.message || '查询成功',
          data: {
            records: data.records || [],
            total: data.total || 0,
            size: data.size || size,
            current: data.current || current,
            pages: data.pages || 0
          }
        }
      } else {
        console.error('查询标签患者失败，响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `查询失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('查询标签患者异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 403:
            return { success: false, message: '没有权限查看此标签的患者' }
          case 404:
            return { success: false, message: '标签不存在' }
          case 400:
            return { success: false, message: data?.message || '请求参数错误' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试' }
          default:
            return { success: false, message: data?.message || '查询失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '查询失败，请重试' }
      }
    }
  }

  /**
   * 根据一级标签ID查询其所有二级标签的患者列表（去重）
   * @param {string|number} parentTagId - 一级标签ID
   * @param {number} current - 当前页码（从1开始）
   * @param {number} size - 每页条数
   * @returns {Promise<Object>} 去重后的患者列表数据
   */
  async getPatientsByParentTagId(parentTagId, current = 1, size = 10) {
    try {
      console.log('=== 根据一级标签ID查询所有二级标签的患者 ===')
      console.log('查询参数:', { parentTagId, current, size })

      // 验证必填参数
      if (!parentTagId) {
        return {
          success: false,
          message: '一级标签ID不能为空'
        }
      }

      // 构建查询参数
      const params = {
        parentTagId: parentTagId,
        current: current.toString(),
        size: size.toString()
      }

      console.log('发送请求:', '/sys-tags/getPatientsByParentTagId')
      console.log('请求参数:', params)

      const response = await apiClient.get('/sys-tags/getPatientsByParentTagId', { params })

      console.log('查询一级标签下患者响应:', response)
      console.log('响应状态码:', response.status)
      console.log('响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        const data = response.data.data || {}

        return {
          success: true,
          message: response.data.message || '查询成功',
          data: {
            records: data.records || [],
            total: data.total || 0,
            size: data.size || size,
            current: data.current || current,
            pages: data.pages || 0
          }
        }
      } else {
        console.error('查询一级标签下患者失败，响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `查询失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('查询一级标签下患者异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 403:
            return { success: false, message: '没有权限查看此标签的患者' }
          case 404:
            return { success: false, message: '标签不存在或接口不存在，使用备用方案' }
          case 400:
            return { success: false, message: data?.message || '请求参数错误' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试' }
          default:
            return { success: false, message: data?.message || '查询失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '查询失败，请重试' }
      }
    }
  }

  /**
   * 备用方案：通过前端逻辑获取一级标签下所有二级标签的患者（去重）
   * 当后端没有提供专门的接口时使用
   * @param {Object} parentTag - 一级标签对象
   * @param {number} current - 当前页码（从1开始）
   * @param {number} size - 每页条数
   * @returns {Promise<Object>} 去重后的患者列表数据
   */
  async getPatientsByParentTagIdFallback(parentTag, current = 1, size = 10) {
    try {
      console.log('=== 使用备用方案查询一级标签下患者 ===')
      console.log('一级标签:', parentTag)

      if (!parentTag) {
        return {
          success: false,
          message: '标签数据不存在',
          data: { records: [], total: 0, size: size, current: current, pages: 0 }
        }
      }

      if (!parentTag.children || parentTag.children.length === 0) {
        console.log('一级标签没有子标签，直接查询自己的患者')
        try {
          return await this.getPatientsByTagId(parentTag.id, current, size)
        } catch (error) {
          console.error('查询一级标签自身患者失败:', error)
          return {
            success: false,
            message: '查询患者失败',
            data: { records: [], total: 0, size: size, current: current, pages: 0 }
          }
        }
      }

      // 获取所有二级标签的患者
      const allPatients = new Map() // 使用Map去重，key为患者ID

      console.log('开始查询二级标签:', parentTag.children.map(child => ({ id: child.id, name: child.tagName })))

      // 并行查询所有二级标签的患者
      const promises = parentTag.children.map(async(childTag) => {
        try {
          // 验证子标签数据
          if (!childTag || !childTag.id) {
            console.warn('跳过无效的子标签:', childTag)
            return []
          }

          console.log(`查询二级标签"${childTag.tagName}"(ID:${childTag.id})的患者`)
          const result = await this.getPatientsByTagId(childTag.id, 1, 1000) // 使用大的size获取所有患者

          if (result && result.success && result.data && result.data.records) {
            console.log(`二级标签"${childTag.tagName}"有${result.data.records.length}个患者`)
            return result.data.records.map(patient => ({
              ...patient,
              sourceTagName: childTag.tagName, // 记录来源标签
              sourceTagId: childTag.id
            }))
          } else {
            console.log(`二级标签"${childTag.tagName}"查询失败:`, result?.message || '未知错误')
            return []
          }
        } catch (error) {
          console.error(`查询二级标签"${childTag.tagName}"患者异常:`, error)
          return []
        }
      })

      const results = await Promise.all(promises)

      // 合并并去重患者数据
      results.forEach(patients => {
        if (Array.isArray(patients)) {
          patients.forEach(patient => {
            if (patient && typeof patient === 'object') {
              const patientKey = patient.patientId || patient.id || patient.userId
              if (patientKey && !allPatients.has(patientKey)) {
                allPatients.set(patientKey, patient)
              }
            }
          })
        }
      })

      const uniquePatients = Array.from(allPatients.values())
      console.log(`合并后去重的患者数量: ${uniquePatients.length}`)

      // 实现前端分页
      const total = uniquePatients.length
      const startIndex = (current - 1) * size
      const endIndex = startIndex + size
      const paginatedPatients = uniquePatients.slice(startIndex, endIndex)

      console.log(`分页结果: 第${current}页，每页${size}条，当前页${paginatedPatients.length}条`)

      return {
        success: true,
        message: `查询成功，共找到${total}个患者（已去重）`,
        data: {
          records: paginatedPatients,
          total: total,
          size: size,
          current: current,
          pages: Math.ceil(total / size)
        }
      }
    } catch (error) {
      console.error('备用方案查询一级标签下患者异常:', error)
      return {
        success: false,
        message: '查询失败，请重试',
        data: {
          records: [],
          total: 0,
          size: size,
          current: current,
          pages: 0
        }
      }
    }
  }

  /**
   * 格式化时间为API需要的格式
   * @param {string} timeStr - 时间字符串
   * @returns {string} 格式化后的时间
   */
  formatTimeForAPI(timeStr) {
    try {
      if (!timeStr) {
        return new Date().toISOString().replace(/\.\d{3}Z$/, '')
      }

      const date = new Date(timeStr)
      if (isNaN(date.getTime())) {
        return new Date().toISOString().replace(/\.\d{3}Z$/, '')
      }

      // 转换为API需要的格式 "2025-07-03T12:10:00"
      return date.toISOString().replace(/\.\d{3}Z$/, '')
    } catch (error) {
      console.warn('时间格式化失败:', error, timeStr)
      return new Date().toISOString().replace(/\.\d{3}Z$/, '')
    }
  }

  /**
   * 修改标签信息
   * @param {Object} tagData - 标签数据
   * @param {number} tagData.id - 标签唯一ID
   * @param {string} tagData.tagName - 标签名称
   * @param {number} tagData.parentId - 父级标签ID（0表示一级）
   * @param {number} tagData.level - 标签层级
   * @param {string} [tagData.description] - 标签描述
   * @param {string} tagData.createdTime - 创建时间（ISO 8601格式）
   * @param {string} tagData.updatedTime - 最后一次更新时间（ISO 8601格式）
   * @returns {Promise<Object>} 修改结果
   */
  async updateTag(tagData) {
    try {
      console.log('=== 修改标签信息 ===')
      console.log('标签数据:', tagData)

      // 验证必填字段
      if (!tagData.id) {
        return {
          success: false,
          message: '标签ID不能为空'
        }
      }

      if (!tagData.tagName || tagData.tagName.trim() === '') {
        return {
          success: false,
          message: '标签名称不能为空'
        }
      }

      if (tagData.tagName.length > 30) {
        return {
          success: false,
          message: '标签名称不能超过30个字符'
        }
      }

      if (tagData.description && tagData.description.length > 200) {
        return {
          success: false,
          message: '标签描述不能超过200个字符'
        }
      }

      if (tagData.parentId === undefined || tagData.parentId === null) {
        return {
          success: false,
          message: '父级标签ID不能为空'
        }
      }

      if (tagData.level === undefined || tagData.level === null) {
        return {
          success: false,
          message: '标签层级不能为空'
        }
      }

      // 构建请求数据，确保数据类型正确
      const requestData = {
        id: parseInt(tagData.id),
        tagName: tagData.tagName.trim(),
        parentId: parseInt(tagData.parentId),
        level: parseInt(tagData.level),
        description: tagData.description || '',
        createdTime: this.formatTimeForAPI(tagData.createdTime),
        updatedTime: this.formatTimeForAPI(new Date().toISOString()) // 使用当前时间作为更新时间
      }

      // 数据格式验证
      if (isNaN(requestData.id) || requestData.id <= 0) {
        return {
          success: false,
          message: '标签ID格式错误'
        }
      }

      if (isNaN(requestData.parentId)) {
        return {
          success: false,
          message: '父级标签ID格式错误'
        }
      }

      if (isNaN(requestData.level) || requestData.level < 1 || requestData.level > 4) {
        return {
          success: false,
          message: '标签层级格式错误，必须为1-4级'
        }
      }

      console.log('发送的请求数据:', requestData)
      console.log('请求URL:', '/sys-tags/updateTag')
      console.log('请求方法:', 'PUT')
      console.log('请求数据类型检查:', {
        id: typeof requestData.id,
        tagName: typeof requestData.tagName,
        parentId: typeof requestData.parentId,
        level: typeof requestData.level,
        description: typeof requestData.description,
        createdTime: typeof requestData.createdTime,
        updatedTime: typeof requestData.updatedTime
      })

      const response = await apiClient.put('/sys-tags/updateTag', requestData)

      console.log('修改标签响应:', response)
      console.log('响应状态码:', response.status)
      console.log('响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        return {
          success: true,
          message: response.data.message || '标签修改成功',
          data: response.data.data
        }
      } else {
        console.error('修改标签失败，响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `标签修改失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('修改标签异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 403:
            return { success: false, message: '没有权限修改此标签' }
          case 404:
            return { success: false, message: '标签不存在或修改接口不存在' }
          case 400:
            return { success: false, message: data?.message || '请求参数错误' }
          case 500:
            console.error('服务器500错误详情:', {
              url: '/sys-tags/updateTag',
              method: 'PUT',
              requestData: error.config?.data,
              responseData: data
            })

            // 提供更详细的500错误信息
            let errorMsg = '服务器内部错误，可能的原因：\n'
            errorMsg += '• 时间格式不正确\n'
            errorMsg += '• 标签ID不存在\n'
            errorMsg += '• 数据类型错误\n'

            if (data?.message) {
              errorMsg += `\n服务器错误信息: ${data.message}`
            }

            return {
              success: false,
              message: errorMsg
            }
          default:
            return { success: false, message: data?.message || '修改标签失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '修改标签失败，请重试' }
      }
    }
  }

  /**
   * 测试修改标签接口连通性
   * @returns {Promise<Object>} 测试结果
   */
  async testUpdateTagAPI() {
    try {
      console.log('=== 测试修改标签接口连通性 ===')

      // 使用一个不存在的标签ID来测试接口是否可访问
      const testData = {
        id: 99999,
        tagName: '测试标签',
        parentId: 0,
        level: 1,
        description: '测试描述',
        createdTime: this.formatTimeForAPI(new Date().toISOString()),
        updatedTime: this.formatTimeForAPI(new Date().toISOString())
      }

      console.log('测试数据:', testData)
      console.log('测试URL:', '/sys-tags/updateTag')

      const response = await apiClient.put('/sys-tags/updateTag', testData)

      console.log('测试响应:', response)

      return {
        success: true,
        message: '修改标签接口可访问',
        data: response.data
      }
    } catch (error) {
      console.log('测试修改标签接口结果:', {
        status: error.response?.status,
        message: error.message,
        data: error.response?.data
      })

      // 如果是404或其他业务错误，说明接口本身是通的
      if (error.response?.status === 404 || error.response?.status === 400 || error.response?.status === 500) {
        return {
          success: true,
          message: '修改标签接口可访问（业务逻辑错误属于正常）',
          data: error.response.data
        }
      }

      return {
        success: false,
        message: `修改标签接口访问失败: ${error.message}`,
        error: error.response?.data
      }
    }
  }

  /**
   * 删除患者标签
   * @param {number} patientId - 患者ID
   * @param {Array<string>} tagIds - 标签ID列表
   * @returns {Promise<Object>} API响应
   */
  async removeTagsFromPatient(patientId, tagIds) {
    try {
      console.log('删除患者标签:', { patientId, tagIds })

      // 确保tagIds是数组格式
      const tagIdsArray = Array.isArray(tagIds) ? tagIds : [tagIds]
      console.log('转换后的tagIdsArray:', tagIdsArray)

      // 验证患者ID
      if (!patientId) {
        return {
          success: false,
          message: '患者ID不能为空'
        }
      }

      // 验证标签ID
      if (!tagIdsArray.length) {
        return {
          success: false,
          message: '请选择要删除的标签'
        }
      }

      // 尝试方法1：按照接口文档的array[string]格式，如["1,2"]
      console.log('=== 尝试方法1：接口文档格式 ===')
      try {
        const method1Params = new URLSearchParams()
        method1Params.append('patientId', parseInt(patientId))
        method1Params.append('tagIds', `["${tagIdsArray.join(',')}"]`)

        console.log('方法1参数:', method1Params.toString())
        const response1 = await apiClient.post(`/sys-tags/removeTagsFromPatient?${method1Params.toString()}`)

        if (response1.data && response1.data.code === 0) {
          console.log('方法1成功!')
          return {
            success: true,
            message: response1.data.message || '标签删除成功',
            data: response1.data.data
          }
        }
      } catch (error1) {
        console.log('方法1失败:', error1.message)
      }

      // 尝试方法2：每个标签ID作为单独的参数
      console.log('=== 尝试方法2：多个tagIds参数 ===')
      try {
        const method2Params = new URLSearchParams()
        method2Params.append('patientId', parseInt(patientId))
        tagIdsArray.forEach(id => {
          method2Params.append('tagIds', String(id))
        })

        console.log('方法2参数:', method2Params.toString())
        const response2 = await apiClient.post(`/sys-tags/removeTagsFromPatient?${method2Params.toString()}`)

        if (response2.data && response2.data.code === 0) {
          console.log('方法2成功!')
          return {
            success: true,
            message: response2.data.message || '标签删除成功',
            data: response2.data.data
          }
        }
      } catch (error2) {
        console.log('方法2失败:', error2.message)
      }

      // 尝试方法3：JSON数组格式
      console.log('=== 尝试方法3：JSON数组格式 ===')
      try {
        const method3Params = new URLSearchParams()
        method3Params.append('patientId', parseInt(patientId))
        method3Params.append('tagIds', JSON.stringify(tagIdsArray))

        console.log('方法3参数:', method3Params.toString())
        const response3 = await apiClient.post(`/sys-tags/removeTagsFromPatient?${method3Params.toString()}`)

        if (response3.data && response3.data.code === 0) {
          console.log('方法3成功!')
          return {
            success: true,
            message: response3.data.message || '标签删除成功',
            data: response3.data.data
          }
        }
      } catch (error3) {
        console.log('方法3失败:', error3.message)
      }

      // 尝试方法4：使用request body而不是query params
      console.log('=== 尝试方法4：Request Body格式 ===')
      const response = await apiClient.post('/sys-tags/removeTagsFromPatient', {
        patientId: parseInt(patientId),
        tagIds: tagIdsArray
      })

      console.log('方法4 - 删除标签响应:', response)
      console.log('方法4 - 响应状态码:', response.status)
      console.log('方法4 - 响应数据:', response.data)

      if (response.data && response.data.code === 0) {
        console.log('方法4成功!')
        return {
          success: true,
          message: response.data.message || '标签删除成功',
          data: response.data.data
        }
      } else {
        console.error('所有方法都失败了')
        console.error('最后一次尝试的响应码:', response.data?.code)
        console.error('完整错误响应:', response.data)
        return {
          success: false,
          message: response.data?.message || `标签删除失败 (错误码: ${response.data?.code})`
        }
      }
    } catch (error) {
      console.error('所有删除方法都失败了，最终异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 404:
            return { success: false, message: '患者或标签不存在' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试\n\n可能原因：\n1. 接口参数格式不正确\n2. 服务器内部错误\n3. 数据库连接问题' }
          default:
            return { success: false, message: data?.message || '删除标签失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '删除标签失败，请重试' }
      }
    }
  }

  /**
   * 修改患者标签 - 安全版本
   * @param {number} patientId - 患者ID
   * @param {Array<string>} tagIds - 标签ID列表
   * @returns {Promise<Object>} API响应
   */
  async updatePatientTags(patientId, tagIds) {
    try {
      console.log('=== 安全修改患者标签 ===')
      console.log('患者ID:', patientId)
      console.log('新的标签ID列表:', tagIds)

      // 确保tagIds是数组格式，过滤空值
      let newTagIds = []
      if (tagIds && tagIds.length > 0) {
        newTagIds = Array.isArray(tagIds) ? tagIds.map(id => String(id)).filter(id => id && id !== 'undefined' && id !== 'null') : [String(tagIds)]
      }
      console.log('转换后的新标签ID列表:', newTagIds)

      // 验证患者ID
      if (!patientId) {
        return {
          success: false,
          message: '患者ID不能为空'
        }
      }

      // 先获取当前患者的标签
      console.log('获取当前患者标签...')
      const currentTagsResult = await this.getTagsByPatientId(patientId)

      let currentTagIds = []
      if (currentTagsResult.success && currentTagsResult.data) {
        currentTagIds = currentTagsResult.data.map(tag => String(tag.id))
      }
      console.log('当前标签ID列表:', currentTagIds)

      // 计算需要删除和添加的标签
      const tagsToRemove = currentTagIds.filter(id => !newTagIds.includes(id))
      const tagsToAdd = newTagIds.filter(id => !currentTagIds.includes(id))

      console.log('需要删除的标签:', tagsToRemove)
      console.log('需要添加的标签:', tagsToAdd)

      // 如果没有变化，直接返回成功
      if (tagsToRemove.length === 0 && tagsToAdd.length === 0) {
        console.log('标签没有变化，无需更新')
        return {
          success: true,
          message: '标签更新成功（无变化）'
        }
      }

      // 删除不需要的标签
      if (tagsToRemove.length > 0) {
        console.log('删除不需要的标签...')
        const removeResult = await this.removeTagsFromPatient(patientId, tagsToRemove)
        if (!removeResult.success) {
          console.error('删除标签失败:', removeResult.message)
          return {
            success: false,
            message: `删除标签失败: ${removeResult.message}`
          }
        }
        console.log('删除标签成功')
      }

      // 添加新标签
      if (tagsToAdd.length > 0) {
        console.log('添加新标签...')
        for (const tagId of tagsToAdd) {
          const addResult = await this.bindTagToPatient(patientId, tagId)
          if (!addResult.success) {
            console.error('添加标签失败:', addResult.message)
            return {
              success: false,
              message: `添加标签失败: ${addResult.message}`
            }
          }
        }
        console.log('添加标签成功')
      }

      console.log('患者标签更新完成')
      return {
        success: true,
        message: '标签更新成功'
      }
    } catch (error) {
      console.error('修改患者标签异常:', error)
      console.error('错误详情:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      })

      if (error.response) {
        const status = error.response.status
        const data = error.response.data

        switch (status) {
          case 401:
            return { success: false, message: '登录已过期，请重新登录' }
          case 404:
            return { success: false, message: '患者或标签不存在' }
          case 500:
            return { success: false, message: '服务器繁忙，请稍后重试' }
          default:
            return { success: false, message: data?.message || '标签更新失败' }
        }
      } else if (error.request) {
        return { success: false, message: '网络连接失败，请检查网络' }
      } else {
        return { success: false, message: '标签更新失败，请重试' }
      }
    }
  }

  /**
   * 根据患者ID查询对应标签
   * @param {string|number} patientId - 患者ID
   * @returns {Promise<Object>} 标签列表数据
   */
  async getTagsByPatientId(patientId) {
    try {
      console.log('=== 根据患者ID查询标签 ===')
      console.log('患者ID:', patientId)

      // 验证必填参数
      if (!patientId) {
        return {
          success: false,
          message: '患者ID不能为空',
          data: []
        }
      }

      console.log('发送请求到 /sys-tags/getTagsByPatientId')
      console.log('请求参数:', { patientId })

      // 发送GET请求
      const response = await apiClient.get('/sys-tags/getTagsByPatientId', {
        params: { patientId: String(patientId) }
      })

      console.log('查询患者标签API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('查询患者标签成功')

        // 格式化标签数据
        const formattedTags = this.formatTagsData(data.data || [])

        console.log('格式化后的患者标签数据:', formattedTags)

        return {
          success: true,
          message: data.message || '查询患者标签成功',
          data: formattedTags
        }
      } else {
        console.error('查询患者标签失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '查询患者标签失败',
          data: []
        }
      }
    } catch (error) {
      console.error('查询患者标签异常:', error)

      let errorMessage = '查询患者标签失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const status = error.response.status
        const errorData = error.response.data || {}

        if (status === 500) {
          errorMessage = '服务器繁忙，请稍后重试'
        } else if (status === 404) {
          errorMessage = '标签接口不存在或患者不存在'
        } else if (status === 401) {
          errorMessage = '登录已过期，请重新登录'
        } else if (status === 403) {
          errorMessage = '没有权限访问患者标签数据'
        } else {
          errorMessage = errorData.message || errorData.msg || `服务器错误 (${status})`
        }
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: []
      }
    }
  }

  /**
   * 测试标签绑定接口连通性
   * @returns {Promise<Object>} 测试结果
   */
  async testBindTagAPI() {
    try {
      console.log('=== 测试标签绑定接口连通性 ===')

      // 使用一个无效的患者ID来测试接口是否可访问
      const testParams = new URLSearchParams()
      testParams.append('patientId', 99999)
      testParams.append('tagIds', '["999"]')

      console.log('测试参数:', testParams.toString())
      console.log('测试URL:', '/sys-tags/bindTagToPatient')

      const response = await apiClient.post(`/sys-tags/bindTagToPatient?${testParams.toString()}`)

      console.log('测试响应:', response)

      return {
        success: true,
        message: '接口可访问',
        data: response.data
      }
    } catch (error) {
      console.log('测试接口结果:', {
        status: error.response?.status,
        message: error.message,
        data: error.response?.data
      })

      // 如果是404或其他业务错误，说明接口本身是通的
      if (error.response?.status === 404 || error.response?.status === 400) {
        return {
          success: true,
          message: '接口可访问（业务逻辑错误属于正常）',
          data: error.response.data
        }
      }

      return {
        success: false,
        message: `接口访问失败: ${error.message}`,
        error: error.response?.data
      }
    }
  }

  /**
   * 根据标签名称或编码模糊搜索标签
   * @param {string} searchText - 搜索关键词（标签名称或编码）
   * @returns {Promise<Object>} 搜索结果
   */
  async searchTagsByName(searchText) {
    try {
      console.log('=== 根据标签名称/编码模糊搜索标签 ===')
      console.log('搜索关键词:', searchText)

      // 验证必填参数
      if (!searchText || searchText.trim() === '') {
        return {
          success: false,
          message: '搜索关键词不能为空',
          data: []
        }
      }

      const trimmedText = searchText.trim()
      console.log('发送请求到 /sys-tags/searchByTagName')
      console.log('请求参数:', { tagName: trimmedText })

      // 发送GET请求
      const response = await apiClient.get('/sys-tags/searchByTagName', {
        params: { tagName: trimmedText }
      })

      console.log('标签搜索API原始响应:', response)

      const data = response.data || response
      if (data.code === 0) {
        console.log('标签搜索成功')

        // 格式化搜索结果，保持树形结构
        const formattedResults = this.formatTagsData(data.data || [])

        console.log('格式化后的搜索结果:', formattedResults)

        return {
          success: true,
          message: data.message || '搜索成功',
          data: formattedResults,
          total: formattedResults.length
        }
      } else {
        console.error('标签搜索失败:', data)
        return {
          success: false,
          message: data.message || data.msg || '搜索失败',
          data: [],
          total: 0
        }
      }
    } catch (error) {
      console.error('标签搜索异常:', error)

      let errorMessage = '搜索标签失败'
      if (error.response) {
        console.error('API响应错误:', error.response)
        const status = error.response.status
        const errorData = error.response.data || {}

        if (status === 500) {
          errorMessage = '服务器繁忙，请稍后重试'
        } else if (status === 404) {
          errorMessage = '搜索接口不存在'
        } else if (status === 401) {
          errorMessage = '登录已过期，请重新登录'
        } else if (status === 403) {
          errorMessage = '没有权限搜索标签'
        } else {
          errorMessage = errorData.message || errorData.msg || `服务器错误 (${status})`
        }
      } else if (error.request) {
        console.error('网络请求错误:', error.request)
        errorMessage = '网络连接失败，请检查网络设置'
      } else {
        console.error('请求配置错误:', error.message)
        errorMessage = error.message || '请求失败'
      }

      return {
        success: false,
        message: errorMessage,
        data: [],
        total: 0
      }
    }
  }

  /**
   * 扁平化搜索结果，将树形结构转换为列表（用于显示搜索结果）
   * @param {Array} searchResults - 树形搜索结果
   * @returns {Array} 扁平化的搜索结果
   */
  flattenSearchResults(searchResults) {
    const flatResults = []

    const processTag = (tag, parentPath = '') => {
      // 构建完整路径，显示标签的层级关系
      const currentPath = parentPath ? `${parentPath} > ${tag.tagName}` : tag.tagName

      // 添加当前标签
      flatResults.push({
        ...tag,
        fullPath: currentPath,
        displayName: tag.tagName,
        pathLevel: parentPath ? parentPath.split(' > ').length : 0
      })

      // 递归处理子标签
      if (tag.children && tag.children.length > 0) {
        tag.children.forEach(child => {
          processTag(child, currentPath)
        })
      }
    }

    searchResults.forEach(tag => processTag(tag))

    return flatResults
  }

  /**
   * 高亮搜索关键词
   * @param {string} text - 原始文本
   * @param {string} searchText - 搜索关键词
   * @returns {string} 带高亮标记的文本
   */
  highlightSearchText(text, searchText) {
    if (!text || !searchText) return text

    const regex = new RegExp(`(${searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
    return text.replace(regex, '<mark>$1</mark>')
  }
}

// 创建标签API实例
export const tagsApi = new TagsApi()

// 默认导出
export default tagsApi
